import { Fragment, useState } from 'react';
import { useSnackbar } from 'notistack';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import { IUpdateNursingRecord } from 'apis/main/type';
import { deleteNursingRecord } from 'apis/main';
import usePatient from 'store/patient/usePatient';

interface Props extends IUpdateNursingRecord {
  refetch: () => void;
}

const ActionButtons = ({
  refetch,
  content,
  record_type,
  record_time,
  ...otherProps
}: Props) => {
  const { onSelectedNursingRecord } = usePatient();
  const { enqueueSnackbar } = useSnackbar();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const onConfig = () => {
    onSelectedNursingRecord({
      content,
      record_type,
      record_time,
      ...otherProps,
    });
    handleClose();
  };

  const onDelete = () => {
    const isConfirm = window.confirm(
      `Are you sure you want to delete the nursing record?
- In actual medical institutions, even if the nursing record is deleted, it remains separately on the server. Please be cautious when deleting nursing records while working as a clinical nurse.`
    );
    if (!isConfirm) return handleClose();

    deleteNursingRecord({
      ...otherProps,
      record_id: otherProps.nursing_record_id,
    })
      .then(() => {
        refetch();
        const message = 'Nursing record deleted.';
        enqueueSnackbar(message, { variant: 'success' });
      })
      .catch(e => {
        const message = `Failed to delete nursing records.\nError: ${e}`;
        enqueueSnackbar(message, { variant: 'error' });
      })
      .finally(handleClose);
  };

  return (
    <Fragment>
      <IconButton size="small" onClick={handleClick}>
        <MoreHorizIcon />
      </IconButton>
      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        PaperProps={{ sx: { width: 180 } }}
      >
        <MenuItem onClick={onConfig}>Edit</MenuItem>
        <MenuItem onClick={onDelete}>Delete</MenuItem>
      </Menu>
    </Fragment>
  );
};

export default ActionButtons;
